export { default } from './BotoSeguir';
